<template>
  <div class="write-off-option-list">
    <div
      v-for="(option, index) in writeOffOptionList"
      class="write-off-option"
      :class="{ 'selected': option.selected }"
      :key="`write_off_option_${index}`"
      @click="onSelect(option)"
    >
      {{ $t(option.description) }}
    </div>
  </div>
</template>

<script>
import {
  ONCE,
  DAILY,
  WEEKLY,
  MONTHLY,
  SEMI_ANNUALLY,
  ANNUALLY,
  SELECTIVELY,
  WRITE_OFF_OPTIONS
} from '../const';

export const STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export default {
  name: 'WriteOffOptions',
  props: {
    tariff: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.initializeData();
  },
  data() {
    return {
      writeOffOptionList: [],

      writeOffOnce: {
        description: 'once.time',
        periodicity: ONCE,
      },

      writeOffOnceSelectively: {
        description: 'common.selectively',
        periodicity: SELECTIVELY,
      },

      writeOffOptions: {
        [DAILY]: {
          description: 'common.daily',
          periodicity: DAILY,
        },
        [WEEKLY]: {
          description: 'common.weekly',
          periodicity: WEEKLY,
        },
        [MONTHLY]: {
          description: 'common.monthly',
          periodicity: MONTHLY,
        },
        [SEMI_ANNUALLY]: {
          description: 'common.semi-annually',
          periodicity: SEMI_ANNUALLY,
        },
        [ANNUALLY]: {
          description: 'common.annually',
          periodicity: ANNUALLY,
        },
      },
    };
  },
  methods: {
    initializeData() {
      const { per: periodicity, oneTimePayment } = this.tariff.subscription;

      if (periodicity === this.writeOffOnceSelectively.periodicity) {
        this.prepareSelectivelyList();
        return;
      }

      const optionList = [{
        ...this.writeOffOptions[periodicity],
        selected: true,
      }];

      if (oneTimePayment) {
        optionList.push({
          ...this.writeOffOnce,
          selected: false,
        });
      }

      this.writeOffOptionList = optionList;
    },
    prepareSelectivelyList() {
      const { oneTimePayment } = this.tariff.subscription;

      const optionList = Object.keys(this.writeOffOptions)
        .map(option => {
          return {
            ...this.writeOffOptions[option],
            selected: false,
          };
        });

      if (oneTimePayment) {
        optionList.push({
          ...this.writeOffOnce,
          selected: false,
        });
      }

      optionList[0].selected = true;
      this.writeOffOptionList = optionList;
    },
    onSelect(option) {
      this.writeOffOptionList.forEach(option => {
        option.selected = false;
      });

      option.selected = true;

      if (!this.$validate.isObjectWithFields(WRITE_OFF_OPTIONS, [option.periodicity])) {
        this.$emit('select', null);
        return;
      }

      this.$emit('select', option.periodicity);
    },
  },
};
</script>

<style lang="sass" scoped>
  .write-off-option-list
    *
      margin: 0 10px 10px 0

  .write-off-option
    display: inline-block
    padding: 13px 15px
    background: #fff
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px

    &.selected
      color: #fff
      background: #212121

    &:hover
      cursor: pointer
</style>
